import PrimarySchoolService from "../services/PrimarySchoolService";
import SearchService from "../services/SearchService";
import router from "@/router";

const uuidv4 = require("uuid/v4");

const getDefaultState = () => ({
	count: 0,
	selectedSchool: "",
	selectedSchoolName: "",
	school: {
		uuid: "",
		school_name: "",
		registered_with_gov: false,
		country: "",
		region: "",
		district: "",
		address: "",
		lat: null,
		lng: null,
	},
	schools: [],
	schoolStudents: [],
	schoolTrainers: [],
	studentFormEntries: [],
	primarySchoolLeanerData: [],
});

const primarySchools = {
	namespaced: true,
	state: getDefaultState(),
	mutations: {
		count(state, val) {
			state.count = val;
		},
		school_name(state, val) {
			state.school.school_name = val;
		},
		registered_with_gov(state, val) {
			state.school.registered_with_gov = val;
		},
		country(state, val) {
			state.school.country = val;
		},
		region(state, val) {
			state.school.region = val;
		},
		district(state, val) {
			state.school.district = val;
		},
		lat(state, val) {
			state.school.lat = val;
		},
		lng(state, val) {
			state.school.lng = val;
		},
		selectedSchool(state, val) {
			state.selectedSchool = val;
		},
		schools(state, val) {
			state.schools = val;
		},
		resetSchools(state) {
			Object.assign(state, getDefaultState());
		},
		primaryLeanerSchoolData(state, val) {
			state.primaryLeanerSchoolData = val;
		},
	},
	actions: {
		async RESET_SCHOOLS_STATE(context) {
			await context.commit("resetSchools");
		},
		async GET_SCHOOLS(context, pageInfo) {
			const { currentPage, perPage } = pageInfo;
			const res = await PrimarySchoolService.fetchSchools(currentPage, perPage);
			let data = res.data.schools;
			context.commit("schools", data);
		},
		async SEARCH_SCHOOLS(context) {
			const table = "primary_schools";
			const res = await SearchService.searchName(
				table,
				context.rootState.searches.name
			);
			const data = await res.data.results;
			console.log(data);
			context.commit("schools", data);
		},
		async GET_SCHOOLS_EXPORT(context) {
			const res = await PrimarySchoolService.fetchSchoolsExport();
			const data = res.data.schools;
			context.rootState.primarySchools.schoolsExport = data;
		},
		async GET_SCHOOL(context) {
			const school = await PrimarySchoolService.getSchool({
				id: router.currentRoute.params.id,
			});
			const data = school.data.school[0];
			context.rootState.primarySchools.school = data;
		},
		async CREATE_SCHOOL({ state }) {
			state.school.uuid = uuidv4();
			await PrimarySchoolService.addSchool(state.school);
		},
		async UPDATE_SCHOOL({ state }) {
			await PrimarySchoolService.updateSchool(state.school);
		},
		async GET_SCHOOL_COUNT(context) {
			const payload = await PrimarySchoolService.fetchSchoolCount();
			const { length } = payload.data;
			context.commit("count", parseInt(length));
		},
		async GET_SCHOOL_STUDENTS(context, year) {
			const payload = await PrimarySchoolService.fetchSchoolStudents(year);
			context.rootState.primarySchools.schoolStudents = payload.data.students;
		},
		async GET_SCHOOL_TRAINERS(context) {
			const payload = await PrimarySchoolService.fetchSchoolTrainers();
			context.rootState.primarySchools.schoolTrainers = payload.data.trainers;
		},
		async GET_PRIMARY_SCHOOL_LEANER_DATA(context) {
			const res = await PrimarySchoolService.getPrimarySchoolLeanerData(
				router.currentRoute.params.id
			);
			const data = res.data.result;
			context.commit("primaryLeanerSchoolData", data);
		},
	},
	getters: {
		getSelectedSchool: (state) => state.selectedSchool,
		getRegion: (state) => state.school.region,
		getDistrict: (state) => state.school.district,
		getSchoolName: (state) => state.school.school_name,
		getPrimarySchoolLeanerData: (state) => state.primaryLeanerSchoolData,
	},
};

export default primarySchools;
